import React from "react";
import { Stack } from "@mui/material";
import {Bot, Currency} from "../../../_app/types";
import {Order} from "../../../class/Order";
import FuturesBotLeverage from "./FuturesBotLeverage";
import FuturesBotInvestment from "./FuturesBotInvestment";

interface Props {
  bot: Bot;
  onChangeInvestment: (value: number) => void;
  onChangeLeverage: (value: number) => void;
  tickerPrice: number;
  onChangeCurrency: (value: Currency) => void;
  stepInQuote: number;
  stepInBase: number;
  onChangeStepsCount: (value: number) => void;
  priceStepQuery: number;
  orderList: Order[];
}

const FuturesBotInvestmentSettings = ({
  bot,
  onChangeInvestment,
  onChangeLeverage,
  onChangeCurrency,
  tickerPrice,
  stepInQuote,
  stepInBase,
  priceStepQuery,
  onChangeStepsCount,
  orderList,
}: Props) => {
  return (
    <Stack spacing={1} sx={{ paddingTop: 2 }}>
      <FuturesBotInvestment
        bot={bot}
        base={bot.base}
        quote={bot.quote}
        value={bot.investment}
        leverage={bot.leverage}
        onChange={onChangeInvestment}
        onChangeCurrency={onChangeCurrency}
        tickerPrice={tickerPrice}
        stepInQuote={stepInQuote}
        stepInBase={stepInBase}
        onChangeStepsCount={onChangeStepsCount}
        priceStepQuery={priceStepQuery}
        orderList={orderList}
      />
      <FuturesBotLeverage value={bot.leverage} onChange={onChangeLeverage} />
    </Stack>
  );
};

export default FuturesBotInvestmentSettings;
